<template>
    <vue-draggable-resizable class="ql-selection-cue-marker" :key="handler"
        :style="style()"
        :x="cuePosLeft" :y="cuePosTop"
        :w="cuePosWidth" :h="cuePosHeight"
        :minw="10" :minh="10"
        :parent="true"
        :draggable="editable && !locked" :resizable="editable && !locked"
        @dragging="onDrag"
        @dragstop="onDragStop"
        @resizestop="onResize"
        @activated="onActivate"
        @deactivated="onDeactivate"
    >
        <md-tooltip md-direction="top">{{layer && layer.title + ' ' + cue.title}}</md-tooltip>
    </vue-draggable-resizable>
</template>

<script>
import { mapGetters } from 'vuex';
import vueDragResize from 'vue-draggable-resizable';
/**
 * Component For...
 */
const CueSelectionMarker = {
    name: 'CueSelectionMarker',
    props: ['cue', 'locked', 'editable', 'pageWidth', 'pageHeight'],
    data: function () {
        return {
            dragging: false,
            handler: 0,
            selectedScale: localStorage.getItem('page-print-scale') || 1
        };
    },
    watch: {
        'cue.x': function () {
            if (!this.dragging) {
                this.handler++;
            }
        },
        'cue.y': function () {
            if (!this.dragging) {
                this.handler++;
            }
        },
        'cue.width': function () {
            this.handler++;
        },
        'cue.height': function () {
            this.handler++;
        }
    },
    computed: {
        ...mapGetters([
            'layerByCue',
            'getLayerBoxOpacity',
            'cueBoxOpacityOptions'
        ]),
        layer: function () {
            return this.layerByCue(this.cue);
        },
        cuePosLeft() {
            if (!this.dragging && this.cue.x <= 1) {
                return this.cue.x * this.pageWidth;
            }
            return this.cue.x;
        },
        cuePosTop() {
            if (!this.dragging && this.cue.y <= 1) {
                return this.cue.y * this.pageHeight;
            }
            return this.cue.y;
        },
        cuePosWidth() {
            let cueDefualtWidth = this.cue.width || 20;
            if ((this.cuePosLeft + this.cue.width) > this.pageWidth) {
                cueDefualtWidth = this.pageWidth - this.cuePosLeft;
            }
            return cueDefualtWidth * this.selectedScale;
        },
        cuePosHeight() {
            return (this.cue.height || 20) * this.selectedScale;
        }
    },
    methods: {
        cueColor() {
            const layer = this.layerByCue(this.cue);
            if (layer) return layer.color;

            return '#000000';
        },
        style() {
            const properties = [];

            const layer = this.layerByCue(this.cue);
            const cueColor = (layer && layer.color) || '#000000';
            let boxOpacity = 20;
            if (this.cueBoxOpacityOptions[this.cue.id]) {
                boxOpacity = this.cueBoxOpacityOptions[this.cue.id];
            }
            if (this.cue.boxOpacity) {
                boxOpacity = this.cue.boxOpacity;
            }
            
            boxOpacity = this.getLayerBoxOpacity(this.cue);
            const alpha = Math.round((boxOpacity / 100) * 255);
            const hex = (alpha + 0x10000).toString(16).substr(-2).toUpperCase();

            properties.push('border-color:' + cueColor, 'background-color: ' + cueColor + hex);

            return properties.join(';');
        },
        onDrag(x, y) {
            this.cue.x = x;
            this.cue.y = y;
            this.dragging = true;
        },
        onDragStop(x, y) {
            const cue = {
                ...this.cue,
                x: x,
                y: y
            };
            this.dragging = false;
            this.$emit('updateCue', cue);
            this.onDeactivate();
        },
        onResize(x, y, width, height) {
            const cue = {
                ...this.cue,
                x: x,
                y: y,
                width: width / this.selectedScale,
                height: height / this.selectedScale
            };
            this.$emit('updateCue', cue);
            this.onDeactivate();
        },
        onActivate() {
            this.$emit('activated');
        },
        onDeactivate() {
            this.$emit('deactivated');
        }
    },
    components: {
        'vue-draggable-resizable': vueDragResize
    },
    mounted: function () {}
};

export default CueSelectionMarker;
</script>

<style lang='scss'>
.ql-selection-cue-marker {
    width: 10px;
    height: 10px;
    opacity: 1;
    cursor: move;
    color: black;
    pointer-events: fill;
    background-color: none;
    border: 1px solid black;
    top: 1px;
    z-index: 100 !important;
}

.ql-marker-icon {
    text-rendering: optimizeLegibility;
    vertical-align: middle;
}
</style>


// WEBPACK FOOTER //
// cue-selection-marker.vue?36025186